// useGitConfigs - preloads the parameter values maintained in Git for this package.
//   GET /api/cicd/package-configs?spaceId&packageId&packageName&kennungen&artifactIds
//
// Why at all: the wizard used to take its values from the tenants only, and the snapshot then
// rewrote the Git file with whatever was on screen. Values of a stage that was not touched in
// the current transport were gone afterwards - a transport to QAS deleted the maintained PROD
// values. Git is the truth now, and it is read HERE, before the configuration view prefills its
// fields.
//
// The request names the source package and the suffixes, not finished target package ids: the
// suffix rule belongs in the backend, where the snapshot applies it too.

import { useCallback } from "react";
import { api } from "../../../utils/helpers";
import { useTransportV2, hasWerke, activeWerke } from "../context/TransportV2Context";

export function useGitConfigs() {
  const { state, dispatch } = useTransportV2();

  const laden = useCallback(async () => {
    // Without a space or a package there is nothing to load - but the state MUST still move on,
    // otherwise the configuration view waits forever. An instance group without a space is
    // selectable and yields spaceId = null; the state then stayed on "idle", no parameter was
    // ever loaded, and the footer still reported "all set" - the transport ran without them.
    if (!state.spaceId || !state.pkgId) {
      dispatch({ type: "SET_GIT_CFG_STATE", payload: "leer" });
      return;
    }
    dispatch({ type: "SET_GIT_CFG_STATE", payload: "laedt" });
    const kennungen = hasWerke(state) ? activeWerke(state).map((w) => w.kennung).filter(Boolean) : [];
    const artefakte = Object.keys(state.sel || {});
    const q = new URLSearchParams({
      spaceId: state.spaceId,
      packageId: state.pkgId,
      packageName: state.pkgName || state.pkgId,
      kennungen: kennungen.join(","),
      artifactIds: artefakte.join(","),
    });
    try {
      const r = await api(`/api/cicd/package-configs?${q.toString()}`);
      dispatch({ type: "SET_GIT_CFG", payload: { werke: r?.werke || {}, unvollstaendig: !!r?.unvollstaendig } });
    } catch {
      // Not a hard failure: without a CI/CD project, or before the first snapshot, there is
      // simply nothing to load. The view then falls back to the tenant values.
      dispatch({ type: "SET_GIT_CFG_STATE", payload: "fehler" });
    }
  }, [state, dispatch]);

  return { laden };
}
